import Link from 'corp/components/UI/IsomorphicLink/IsomorphicLink';
import SelectProject from 'corp/components/UI/SelectProject';

import { TaskType } from '@scale/shared-types';
import { IProjectJson } from '@scale/shared/types/project';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';
import { Flex, Heading, Strong, Text, Button } from '@scale/scaleui-radix';

interface ISelectProjectHeaderProps {
  selectedProject?: IProjectJson;
  onSelectProject: (item?: { value: string }) => void;
  taskType?: TaskType;
  includeTestProjects?: boolean;
}

const SelectProjectHeader = ({
  selectedProject,
  onSelectProject,
  taskType,
  includeTestProjects,
}: ISelectProjectHeaderProps) => {
  const clearProject = () => onSelectProject(undefined);
  const remoAdminContext = useRemoAdminCtx();

  if (selectedProject) {
    return (
      <Flex justify="between" align="center">
        <Flex direction="column" gap="2">
          <Heading size="3" align="left" weight="bold">
            Viewing project
          </Heading>
          <Text>
            {selectedProject.name} (<Strong>{selectedProject._id}</Strong>)
          </Text>
        </Flex>
        <Flex gap={'2'}>
          {!remoAdminContext.isRemoAdmin && (
            <Link href={`/lookup/${selectedProject._id}`} target="_blank">
              <Button>Open project</Button>
            </Link>
          )}
          <Button onClick={clearProject}>Change project</Button>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap="2" style={{ zIndex: 4 }}>
      <Heading size="3" align="left" weight="bold">
        Select a project:
      </Heading>
      <SelectProject
        includeTestProjects={!!includeTestProjects}
        onChange={onSelectProject}
        taskType={taskType}
        remoAdminPersonaId={remoAdminContext.currentPersona?._id}
      />
    </Flex>
  );
};

export default SelectProjectHeader;
